export interface PlatformProduct {
  id: string;
  planId: 'premium';
  platform: 'ios' | 'android' | 'both';
  billingInterval: 'monthly' | 'annual';
  displayName: string;
  description: string;
}

export const GOOGLE_PLAY_PRODUCTS: PlatformProduct[] = [
  {
    id: 'kingdom.bible.quiz.family.monthly',
    planId: 'premium',
    platform: 'android',
    billingInterval: 'monthly',
    displayName: 'Family Plan Monthly',
    description: 'Monthly family Premium Bible quiz access.',
  },
  {
    id: 'kingdom.bible.quiz.family.annual',
    planId: 'premium',
    platform: 'android',
    billingInterval: 'annual',
    displayName: 'Family Plan Yearly',
    description: 'Yearly family Premium Bible quiz access.',
  },
];

export const APPLE_PRODUCTS: PlatformProduct[] = [
  {
    id: 'com.kingdombiblequiz.kingdombiblequiz.family.monthly',
    planId: 'premium',
    platform: 'ios',
    billingInterval: 'monthly',
    displayName: 'Family Plan Monthly',
    description: 'Monthly family Premium Bible quiz access.',
  },
  {
    id: 'com.kingdombiblequiz.kingdombiblequiz.family.annual',
    planId: 'premium',
    platform: 'ios',
    billingInterval: 'annual',
    displayName: 'Family Plan Yearly',
    description: 'Yearly family Premium Bible quiz access.',
  },
];

export const getPlatformProducts = (platform: 'ios' | 'android'): PlatformProduct[] => {
  return platform === 'ios' ? APPLE_PRODUCTS : GOOGLE_PLAY_PRODUCTS;
};

export const getPlatformProductIds = (platform: 'ios' | 'android'): string[] => {
  return getPlatformProducts(platform).map((product) => product.id);
};

export const mapProductToPlan = (
  productId: string,
): { planId: 'premium'; billingInterval: 'monthly' | 'annual' } | null => {
  const allProducts = [...APPLE_PRODUCTS, ...GOOGLE_PLAY_PRODUCTS];
  const product = allProducts.find((currentProduct) => currentProduct.id === productId);

  if (!product) {
    return null;
  }

  return {
    planId: product.planId,
    billingInterval: product.billingInterval,
  };
};
